/**
 * Created by Mike Naughton on 10/19/17.
 *
 * A helper utility for use by InverseViewer and Viewer
 */

import _ from "underscore";
import $ from "jquery";
import auth from "app/auth";
import ErrorUtils from "app/utils/ErrorUtils";

export default {
  /**
   * Asynchronously loads metadata about a particular model.
   * @param context The context under which to run this function.
   * @param {Object} [metadata] A hash of information regarding the model to load.
   * @param {Function|String} [metadata.navBase] A string with a link to the model or a function which resolves to such given a single ID argument.
   * @param {String} metadata.urlBase A base URL to which an ID may be appended to perform a query on the model data.
   * @param {String} metadata.nameField The name of the field that should be used to determine a model "name".
   * @param {String} [modelValue] The identifier of the model to load.
   * @return {Promise} A promise which resolves with an object containing a `navUrl` and a `name`.
   */
  loadMetadata: function (metadata, modelValue) {
    var deferred = new $.Deferred();

    if (metadata && modelValue) {
      var url = metadata.urlBase + modelValue;
      var navUrl;

      if (_.isString(metadata.navBase)) {
        navUrl = metadata.navBase + modelValue;
      } else if (_.isFunction(metadata.navBase)) {
        navUrl = metadata.navBase(modelValue);
      }

      $.ajax({
        type: "GET",
        url: url,
        headers: {
          Authorization: "Bearer " + auth.token,
        },
        success: function (data) {
          var name = data[metadata.nameField];

          deferred.resolve({
            navUrl: navUrl,
            name: name,
          });
        },
      }).fail(function (err) {
        ErrorUtils.handleError(
          {
            skipUser: true,
            activity: "loading field data",
          },
          err
        );
        deferred.resolve({
          //just resolve here, since it's not imperative that we have the data
          navUrl: "",
          name: modelValue || "*",
        });
      });
    } else {
      deferred.resolve({
        navUrl: "",
        name: modelValue || "*",
      });
    }

    return deferred.promise();
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/permissions/ViewerHelper.js
// module id = 499
// module chunks = 1